import { createAction, props } from '@ngrx/store';

export const loadOrganizations = createAction(
  '[Organizations] Load Organizations'
);

export const loadOrganizationsSuccess = createAction(
  '[Organizations] Load Organizations Success',
  props<{ data: any }>()
);

export const loadOrganizationsFailure = createAction(
  '[Organizations] Load Organizations Failure',
  props<{ error: any }>()
);

export const clearOrganizationsState = createAction(
  '[Organizations] clear Organizations State',
);
